import $ from 'jquery';
import common from '../base/common';

class Form{

    constructor($form){

        this.$form = $form;
        if(this.$form.data('form')) return;

        this.fileTypeAccepted = new RegExp("(.*?)\.(docx|doc|pdf)$");
        
        this.options = {
            ajax: this.$form.data('form-ajax'),
            validate: this.$form.data('form-validate'),
            emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ 
        }

        this.$form.data('form', true);

        this.onFocus = this.onFocus.bind(this);
        this.onToggleInputs = this.onToggleInputs.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.validate = this.validate.bind(this);
        this.inputFile = this.inputFile.bind(this);

        this.$response = this.$form.find('.Form__Response');
        this.$inputs = this.$form.find('input, select, textarea');
        this.$requireds = this.$inputs.filter('[required],[data-test]');
        this.$inputFilter = this.$requireds.filter('[data-input-filter]');
        this.$togglers = this.$inputs.filter('[data-form-toggle-type]')
        this.$submitButton = this.$form.find('[type="submit"]');
        this.$robotField = this.$inputs.filter('[data-test]');
        
        this.$inputs.on('focusin focusout', this.onFocus)
        this.$togglers.on('change', this.onToggleInputs)

        if(this.options.validate){
            this.$form.attr('novalidate', true);
            this.$form.on('submit', this.onSubmit);
        }

        this.$inputs.on('keydown', this.validate);
        this.$inputs.filter('[type="file"]').on('change', this.inputFile);

    }

    inputFile(e){

        let $field = $(e.target);
        let fieldName = $field[0].files[0].name;
        $field.closest('.InputFile').find('span').text(fieldName.length > 10 ? fieldName.substring(0, 10) + '...' : fieldName);

    }

    onFocus(e){

        let $field = $(e.currentTarget),
            $wrap = $field.closest('.Input__Wrap');

        if(e.type == 'focusin' && $wrap.length)
            $wrap.addClass('Input--focused');
        else if($wrap.length && $field.val().trim() == '')
            $wrap.removeClass('Input--focused');

    }

    onToggleInputs(e){

        let $field = $(e.currentTarget),
            value = $field.val();

        if(value == 'jobs')
            this.$form.find('.input-jobs').show();
        else
            this.$form.find('.input-jobs').hide();

    }

    validate(input){

        let $input;
        if(input.target)
            $input = $(input.currentTarget);
        else
            $input = $(input);

        let isTest = $input.data('test');
        let type = $input.is('textarea') ? 'textarea' : ($input.is('input') ? $input.attr('type') : 'select'),
            value = $input.val().trim();

        if(
            ((type == 'textarea' || type == 'text') && value == '') || 
            (type == 'select' && $input.find('option:selected').length == 0) || 
            (type == 'checkbox' && !$input.is(':checked')) || 
            (type == 'email' && !this.options.emailRegex.test(value))
        ){
            
            // console.log('not valid:',type);
            $input.closest('.Input__Wrap').addClass('Input--not-valid');
            $input.on('change', this.validate);
            
            // checkbox
        
        }else{

            $input.closest('.Input__Wrap').removeClass('Input--not-valid');
            $input.off('change', this.validate);

        }

    }

    onSubmit(e){

        e.preventDefault();

        this.$requireds.each((index, item) => {
            this.validate(item);
        })

        if(!this.$form.find('.Input--not-valid').length){

            this.$submitButton.prop('disabled', true);

            $.post(this.$form.attr('action'), this.$form.serialize(), (data) => {

                this.$submitButton.prop('disabled', false);
                this.$form.find('.Form__Response').text(data.message);
                this.$form.addClass('message-sent');

                setTimeout(() => {

                    this.$form.removeClass('message-sent');
                    this.$form[0].reset();

                },5000)

                // this.$response.addClass('show');
                // this.$response.text(data);
                // this.$submitButton.addClass('Form--sending');
                // this.$submitButton.prop('disabled',true);
                //
                // this.$response.removeClass('Form__Response--error');
                // this.$response.removeClass('show');

            },'json')

        }

    }

}

export default Form;



// WEBPACK FOOTER //
// ./js/components/form.js